import styled from "styled-components"
import { TextButton } from "../Text"
import { motion } from "framer-motion"
import { useNavigate } from "react-router-dom"
import { useSetRecoilState } from "recoil"
import { isMenuExpandedState } from "../../../recoil/common/Header"

const ExpandedMenuDesktop = () => {
  const navigate = useNavigate()
  const setIsMenuExpanded = useSetRecoilState(isMenuExpandedState)

  return (
    <ExpandedMenuDesktopDiv>
      <MenuList>
        <SubMenuButton>회사 소개</SubMenuButton>
        <SubMenuButton>학문프로파일 소개</SubMenuButton>
        <SubMenuButton>학과 정보</SubMenuButton>
      </MenuList>
      <MenuList>
        <SubMenuButton>학문적성 검사 소개</SubMenuButton>
        <SubMenuButton
          onClick={() => {
            setIsMenuExpanded(false)
            navigate("/quiz")
          }}
        >
          검사하기
        </SubMenuButton>
        <SubMenuButton>검사 결과 보기</SubMenuButton>
      </MenuList>
      <MenuList>
        <SubMenuButton>FAQ</SubMenuButton>
        <SubMenuButton>Q&A</SubMenuButton>
        <SubMenuButton>서비스 문의</SubMenuButton>
      </MenuList>
    </ExpandedMenuDesktopDiv>
  )
}

export default ExpandedMenuDesktop

const ExpandedMenuDesktopDiv = styled(motion.div).attrs(() => ({
  variants: {
    hidden: { opacity: 0 },
    show: { opacity: 1 },
  },
  initial: "hidden",
  animate: "show",
  transition: { duration: 0.3 },
}))`
  display: flex;
  position: absolute;
  top: 60px;

  & > * {
    width: 200px;
  }
`

const MenuList = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`

const SubMenuButton = styled(TextButton).attrs(() => ({
  color: "var(--custom-gray)",
  fontSize: 16,
}))`
  height: 45px;
  line-height: 45px;

  &:hover {
    color: var(--custom-blue);
    background-color: var(--custom-anti-flash-white);
  }
`
